import React from 'react';
import { Divider } from '@material-ui/core';
import styled from 'styled-components/macro';
import ReminderCardEngine from '../engine/ReminderCardEngine';
import Button from '../../../components/Button';
import NewReminderWizard from '../engine/AddReminderWizardEngine';
import EmptyState from '../../../components/engine/EmptyPageStateEngine';
import Select from '../../../components/engine/SelectEngine';
import Search from '../../../components/engine/SearchEngine';
import { SortBy } from '../engine/FormBuilderRemindersEngine';
import TemplateEditorManager from '../engine/ReminderEmailTemplateEditorEngine';
import { TextString } from '../../../components/Text';

const ReminderContainer = styled.div`
  background-color: #fff;
  margin: 1rem auto;
  // min-height: calc (100vh - 100px);
  // padding-bottom: 4rem;
  position: relative;
  width: 1060px;
`;

const Controls = styled.div`
  padding: 0.8em;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  border-bottom: 0.8em solid #f7f8fc;
`;

const LeftControls = styled.div`
  & > div {
    margin-right: 0.8em !important;
  }
`;
const RightControls = styled.div``;

const ReminderDivider = styled(Divider)`
  bottom: 1rem;
  height: initial !important;
  position: absolute;
  right: 8%;
  top: 5.8em;
`;

const NoResults = styled.div`
  margin-top: 0.8em;
`;

const FormBuilderRemindersView = ({
  reminders,
  emailDialogTemplateId,
  reminderTemplateListItemValue,
  setReminderTemplateListItemValue,
  onEmailDialogConfirmed,
  reminderData4TemplateEditor,
  ...props
}) => {
  return (
    <>
      <ReminderContainer>
        {!reminders.length ? (
          <>
            {!props.isLoading && (
              <EmptyState
                title="form-builder.reminders.emptyState.title"
                // description="form-builder.reminders.emptyState.description"
                linkText="form-builder.reminders.emptyState.linkText"
                onLinkClicked={() =>
                  props.setIsCreateNewReminderDialogOpen(true)
                }
              />
            )}
          </>
        ) : (
          <>
            <Controls>
              <LeftControls>
                <Select
                  value={props.sortBy}
                  onChange={props.onSortingChanged}
                  options={[
                    { text: 'Sort by active', value: SortBy.ACTIVE },
                    { text: 'Sort by name', value: SortBy.NAME },
                    { text: 'Sort by last updated', value: SortBy.LAST_UPDATE }
                  ]}
                />
                <Search
                  onSearch={props.setSearchValue}
                  value={props.initialValue}
                />
              </LeftControls>
              <RightControls>
                <Button
                  onClick={() => props.setIsCreateNewReminderDialogOpen(true)}
                >
                  Add new reminder
                </Button>
              </RightControls>
            </Controls>

            {props.filteredReminders.length ? (
              props.filteredReminders.map(reminderData => {
                return (
                  <ReminderCardEngine
                    key={reminderData.id}
                    reminderData={reminderData}
                    initAsExpanded={reminderData.id === props.newReminderId}
                  />
                );
              })
            ) : (
              <NoResults>
                <TextString content="form-builder.labels.no_results" />
              </NoResults>
            )}
            <ReminderDivider orientation="vertical" />
          </>
        )}
      </ReminderContainer>
      <NewReminderWizard
        open={props.isCreateNewReminderDialogOpen}
        handleClose={() => props.setIsCreateNewReminderDialogOpen(false)}
      />
      <TemplateEditorManager reminderData={reminderData4TemplateEditor} />
    </>
  );
};

export default FormBuilderRemindersView;
